"use client";

/**
 * NewForm DS hover icon — a panel lifting off the surface behind it, for
 * "this opens a dialog".
 * On hover the front panel rises a little further, so the glyph acts out the
 * thing coming forward rather than a window simply existing.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function OpenModalIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      {/* The surface it sits over — clipped by the panel, so only its far
          corner shows and the two don't read as one shape. */}
      <path d="M6.6 15.4H4.8a1.6 1.6 0 0 1-1.6-1.6V4.8a1.6 1.6 0 0 1 1.6-1.6h9a1.6 1.6 0 0 1 1.6 1.6v1.8" />
      <g className="a-lift-panel">
        <rect x="8.6" y="8.6" width="12.2" height="12.2" rx="2.2" />
        <path d="M8.6 12.2h12.2" />
      </g>
    </HoverIconSvg>
  );
}
